import type { InviteCampaign } from '@peles/shared';
import { isGoingOut } from '../../../hooks/useInvites';

/**
 * Where a campaign opens: its own page in the event workspace, or — in the
 * client portal, which has no such route — the Invites tab with it named.
 */
export function campaignHref(eventId: string, campaignId: string, clientMode: boolean): string {
  return clientMode
    ? `?tab=invites&campaign=${encodeURIComponent(campaignId)}`
    : `/events/${eventId}/invites/${campaignId}`;
}

/** A campaign's state in words, and its colour. */
export function campaignStatusBadge(campaign: Pick<InviteCampaign, 'status' | 'scheduledAt'>): {
  label: string;
  color: string;
} {
  if (isGoingOut(campaign)) return { label: 'Sending', color: '#8b5cf6' };
  switch (campaign.status) {
    case 'SCHEDULED':
      return { label: 'Scheduled', color: '#3b82f6' };
    case 'SENT':
      return { label: 'Sent', color: '#22c55e' };
    case 'CLOSED':
    case 'ARCHIVED':
      return { label: 'Closed', color: '#64748b' };
    default:
      return { label: 'Draft', color: '#94a3b8' };
  }
}
